import { useTranslation } from "react-i18next";
import type { ShapeRecipe } from "../services/naraDoor";

interface Props {
  recipes: ShapeRecipe[];
  /** The template's current extraction recipe id. */
  value: string | undefined;
  busy: boolean;
  failed: boolean;
  /** The chosen recipe id; "" clears the slot. */
  onChange: (recipeId: string) => void;
}

/** The template's default extraction recipe: extraction-mode recipes only, plus None. */
export function ExtractionRecipePicker({ recipes, value, busy, failed, onChange }: Props) {
  const { t } = useTranslation();
  const choices = recipes.filter((recipe) => recipe.input_mode === "extraction");
  // A recipe that left the list stays visible, so the admin can see what is set and clear it.
  const orphan = value && !choices.some((recipe) => recipe.id === value);

  return (
    <div className="bg-card rounded-lg border border-border p-4">
      <label htmlFor="default-extraction-recipe" className="block text-lg font-medium text-foreground">
        {t("projectTemplates.detail.defaultExtractionRecipe")}
      </label>
      <p className="text-sm text-muted-foreground mb-3">{t("projectTemplates.detail.defaultExtractionRecipeDescription")}</p>
      <select
        id="default-extraction-recipe"
        value={value ?? ""}
        disabled={busy}
        onChange={(e) => onChange(e.target.value)}
        className="px-3 py-1.5 text-sm border border-border rounded-lg bg-background min-w-[260px]"
      >
        <option value="">{t("projectTemplates.detail.noExtractionRecipe")}</option>
        {orphan && <option value={value}>{value}</option>}
        {choices.map((recipe) => (
          <option key={recipe.id} value={recipe.id}>
            {recipe.name}
          </option>
        ))}
      </select>
      {failed && (
        <p role="alert" className="mt-2 text-sm text-red-600">
          {t("projectTemplates.detail.saveFailed")}
        </p>
      )}
    </div>
  );
}
